const ChevronRightIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.21967 2.21967C5.92678 1.92678 5.4519 1.92678 5.15901 2.21967C4.86612 2.51256 4.86612 2.98744 5.15901 3.28033L9.37868 7.5L5.15901 11.7197C4.86612 12.0126 4.86612 12.4874 5.15901 12.7803C5.4519 13.0732 5.92678 13.0732 6.21967 12.7803L10.9697 8.03033C11.2626 7.73744 11.2626 7.26256 10.9697 6.96967L6.21967 2.21967Z" />
    </svg>
  );
};

export default ChevronRightIcon;
